const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
   <style>
   * {
        margin: 0;
        padding: 0;
   }
    @keyframes animatedBackground {
        from {
            left: 0px;
        }
        90% {
            left: -562px;
        }
        100%{
            left: 0px;
        }
    }
    .container {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        height: auto;
    }
    .container-content {
        display: flex;
        align-items: flex-start;
        margin-top: 24px;
    }
    .content-text {
        height: auto;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
    }
    .container-content img {
        width: 80px;
        height: 80px;
        border-radius: 100%;
        border: 2px solid #BCBCBC;
        margin-right: 8px;
        object-fit: cover;
    }
    .container-content h2 {
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        color: #3570D2;
        margin: 0;
    }
    .container-lainnya {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 24px;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: #3570D2;
        cursor: pointer;
    }
    .show-full {
        height: 100% !important;
    }
   </style>
 </template>`;

styleElement.register("ecourse-list-narasumber-style");
